import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getFormattedDate } from 'src/utils/date-formatter.util'
import { useAmslerGridImage } from './amsler-grid-card-image.hook'
import { ErrorQueryHandler } from 'src/components/error/error-query-handler.component'
import { CurecallBadge, ECurecallBadgeColor } from '@honestica/curecall-ui'
import { TNeiVariableGroup } from '../nei/nei-card.component'

type TAmslerFormWithVariables = {
  id: number
  updatedAt: string
  variables: {
    amslergrid: TNeiVariableGroup[]
  }
}

export const AmslerHistoryGrids = ({ form }: { form: TAmslerFormWithVariables }) => {
  const { t } = useTranslation()
  const { projectId, patientId } = useParams()

  const {
    id: patientFormId,
    updatedAt,
    variables: { amslergrid: patientVariables },
  } = form

  const rightEye = patientVariables.find((item) => item.name === 'amslerGridDistordedBlurredOrMissingAreasR')

  const leftEye = patientVariables.find((item) => item.name === 'amslerGridDistordedBlurredOrMissingAreasL')

  const {
    isLoading: isLoadingRightImage,
    isError: isErrorRightImage,
    error: rightImageError,
    image: rightImage,
  } = useAmslerGridImage(rightEye?.VariableId ?? 0, patientFormId, patientId as string, projectId as string)

  const {
    isLoading: isLoadingLeftImage,
    isError: isErrorLeftImage,
    error: leftImageError,
    image: leftImage,
  } = useAmslerGridImage(leftEye?.VariableId ?? 0, patientFormId, patientId as string, projectId as string)

  const getGrid = (imageUrl: string) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="132.44" height="132.88" viewBox="0 0 132.44 132.88">
        <g id="Grille_de_test" data-name="Grille de test" transform="translate(0.25 0.25)">
          <g id="Group_189" data-name="Group 189">
            <path
              id="path60"
              d="M-5257.555,1324.495H-5389.5"
              transform="translate(5389.495 -1192.115)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="rect24"
              d="M-5389.5,1145.337h131.94"
              transform="translate(5389.495 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1689"
              d="M-5389.5,1154.3h131.94"
              transform="translate(5389.495 -1147.861)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1691"
              d="M-5389.5,1163.256h131.94"
              transform="translate(5389.495 -1150.382)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1693"
              d="M-5389.5,1172.215h131.94"
              transform="translate(5389.495 -1152.904)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1695"
              d="M-5389.5,1181.171h131.94"
              transform="translate(5389.495 -1154.959)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1697"
              d="M-5389.5,1190.127h131.94"
              transform="translate(5389.495 -1157.253)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1699"
              d="M-5389.5,1199.083h131.94"
              transform="translate(5389.495 -1159.547)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1701"
              d="M-5389.5,1208.04h131.94"
              transform="translate(5389.495 -1161.842)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1703"
              d="M-5389.5,1217h131.94"
              transform="translate(5389.495 -1164.58)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1705"
              d="M-5389.5,1225.958h131.94"
              transform="translate(5389.495 -1166.431)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1707"
              d="M-5389.5,1234.916h131.94"
              transform="translate(5389.495 -1168.725)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1709"
              d="M-5389.5,1243.875h131.94"
              transform="translate(5389.495 -1171.02)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1711"
              d="M-5389.5,1252.83h131.94"
              transform="translate(5389.495 -1173.314)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1713"
              d="M-5389.5,1261.788h131.94"
              transform="translate(5389.495 -1175.609)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1715"
              d="M-5389.5,1270.749h131.94"
              transform="translate(5389.495 -1177.904)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1717"
              d="M-5389.5,1279.706h131.94"
              transform="translate(5389.495 -1180.198)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1719"
              d="M-5389.5,1288.661h131.94"
              transform="translate(5389.495 -1182.492)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1721"
              d="M-5389.5,1297.622h131.94"
              transform="translate(5389.495 -1184.548)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1723"
              d="M-5389.5,1306.578h131.94"
              transform="translate(5389.495 -1187.07)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1725"
              d="M-5389.5,1315.533h131.94"
              transform="translate(5389.495 -1189.591)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
          </g>
          <g id="Group_188" data-name="Group 188" transform="translate(0 0)">
            <path
              id="path62"
              d="M-5389.5,1277.717v-132.38"
              transform="translate(5389.495 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path58"
              d="M-5210.336,1145.337v132.38"
              transform="translate(5342.276 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1807"
              d="M-5380.532,1277.717v-132.38"
              transform="translate(5387.413 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1809"
              d="M-5371.578,1277.717v-132.38"
              transform="translate(5384.892 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1811"
              d="M-5362.621,1277.717v-132.38"
              transform="translate(5382.37 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1813"
              d="M-5353.66,1277.717v-132.38"
              transform="translate(5380.139 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1815"
              d="M-5344.7,1277.717v-132.38"
              transform="translate(5377.801 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1817"
              d="M-5335.747,1277.717v-132.38"
              transform="translate(5375.462 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1819"
              d="M-5326.786,1277.717v-132.38"
              transform="translate(5373.123 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1821"
              d="M-5317.829,1277.717v-132.38"
              transform="translate(5370.783 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1823"
              d="M-5308.873,1277.717v-132.38"
              transform="translate(5368.446 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1825"
              d="M-5299.914,1277.717v-132.38"
              transform="translate(5366.106 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1827"
              d="M-5290.954,1277.717v-132.38"
              transform="translate(5363.767 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1829"
              d="M-5282,1277.717v-132.38"
              transform="translate(5361.428 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1831"
              d="M-5273.038,1277.717v-132.38"
              transform="translate(5359.089 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1833"
              d="M-5264.08,1277.717v-132.38"
              transform="translate(5356.75 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1835"
              d="M-5255.124,1277.717l0-132.38"
              transform="translate(5354.412 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1837"
              d="M-5246.167,1277.717v-132.38"
              transform="translate(5352.073 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1839"
              d="M-5237.212,1277.717v-132.38"
              transform="translate(5349.843 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1841"
              d="M-5228.254,1277.717v-132.38"
              transform="translate(5347.321 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
            <path
              id="path1843"
              d="M-5219.3,1277.717v-132.38"
              transform="translate(5344.799 -1145.337)"
              fill="none"
              stroke="#888"
              strokeMiterlimit="11.339"
              strokeWidth="0.5"
            />
          </g>
          <circle
            id="path1845"
            cx="6.619"
            cy="6.619"
            r="6.619"
            transform="translate(59.836 59.342)"
            opacity="0.8"
          />
        </g>
        <image xlinkHref={imageUrl} width="132.44" height="132.88" />
      </svg>
    )
  }

  if (isLoadingLeftImage || isLoadingRightImage) return <div className="loading" />

  if (isErrorRightImage) return <ErrorQueryHandler error={rightImageError} />

  if (isErrorLeftImage) return <ErrorQueryHandler error={leftImageError} />

  return (
    <div className="c-pb-4 c-pt-4">
      <p className="c-flex c-items-center c-gap-2">
        {t('components.patient.patient-file.body.followup-details.test-date', {
          date: getFormattedDate(new Date(updatedAt)),
        })}
        {((rightEye && rightEye.gridCenterIsHit) || (leftEye && leftEye.gridCenterIsHit)) && (
          <CurecallBadge color={ECurecallBadgeColor.RED} className="tw-text-sm tw-px-2">
            {t('components.patient.patient-file.body.followup-details.center-zone-impacted')}
          </CurecallBadge>
        )}
      </p>

      <div className="c-flex c-gap-6">
        <div>
          <p className="c-font-bold">
            {t('components.patient.patient-file.body.followup-details.left-eye-with-answer', {
              patientAnswer: leftEye?.patientAnswer || 0,
            })}
          </p>
          {getGrid(leftImage)}
        </div>

        <div>
          <p className="c-font-bold">
            {t('components.patient.patient-file.body.followup-details.right-eye', {
              patientAnswer: rightEye?.patientAnswer || 0,
            })}
          </p>
          {getGrid(rightImage)}
        </div>
      </div>
    </div>
  )
}
